import { z } from "zod";
import { FileChange, GitCommit } from "./models.ts";

export const GitWorkspaceAction = z.enum(["inspect", "prepare", "commit", "push", "sync-base", "sync-upstream", "continue-sync", "abort-sync"]);
export type GitWorkspaceAction = z.infer<typeof GitWorkspaceAction>;
export const GitWorkspaceOperation = z.object({
  id: z.string(), action: GitWorkspaceAction, phase: z.string(),
  status: z.enum(["running", "completed", "failed", "conflicts"]),
  error: z.string().optional(), sha: z.string().optional(), pushed: z.boolean().optional(),
});
export type GitWorkspaceOperation = z.infer<typeof GitWorkspaceOperation>;
export const GitWorkspaceState = z.object({
  branch: z.string(), baseBranch: z.string(), headSha: z.string(), baseSha: z.string(),
  workingTreeFingerprint: z.string(), changes: z.array(FileChange), commits: z.array(GitCommit),
  ahead: z.number(), behind: z.number(), baseBehind: z.number(), remoteHeadSha: z.string().nullable(),
  conflicts: z.array(z.string()),
  sync: z.object({ operationId: z.string(), target: z.string(), headBefore: z.string() }).nullable(),
  checkedAt: z.number(),
});
export type GitWorkspaceState = z.infer<typeof GitWorkspaceState>;
export const GitPreparation = z.object({
  id: z.string(), branch: z.string(), baseBranch: z.string(), headSha: z.string(), baseSha: z.string(),
  treeFingerprint: z.string(),
  /** null includes all current edits; [] captures HEAD only. */
  paths: z.array(z.string()).nullable(), createdAt: z.number(),
});
export type GitPreparation = z.infer<typeof GitPreparation>;
export const GitWorkspaceResult = z.object({
  state: GitWorkspaceState.optional(), preparation: GitPreparation.optional(),
  sha: z.string().optional(), filesChanged: z.number().optional(), operation: GitWorkspaceOperation,
  error: z.string().optional(), code: z.string().optional(),
});
export type GitWorkspaceResult = z.infer<typeof GitWorkspaceResult>;
